module.exports = __webpack_public_path__ + "static/media/karnelogga.d82aa373.png";